import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Trophy, Crown, Medal, Quote } from "lucide-react";
import { toast } from "sonner";
import { userApi, apiError, mediaUrl } from "../lib/api";

const MEDAL_COLORS = ["#F5C518", "#C0C4CC", "#CD7F32"];

export default function Ranking() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [frase, setFrase] = useState("");

  useEffect(() => {
    userApi.ranking().then(setData).catch((e) => toast.error(apiError(e)));
    userApi.fraseDia().then((r) => setFrase(r.frase)).catch(() => {});
  }, []);

  const mi = data?.mi_posicion;

  return (
    <div className="min-h-screen bg-cream" data-testid="ranking-page">
      <header className="bg-navy">
        <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between">
          <button data-testid="ranking-back-btn" onClick={() => navigate("/graduacion")} className="flex items-center gap-1.5 text-white/70 hover:text-white text-sm font-semibold transition-colors">
            <ArrowLeft className="w-4 h-4" /> Puntos Graduación
          </button>
          <img src="/logo-supera-light.png" alt="Supera" className="h-11 w-auto object-contain" />
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 py-10">
        {/* Frase del día */}
        <div className="rounded-3xl bg-navy p-6 md:p-8 text-white relative overflow-hidden" data-testid="frase-dia-card">
          <Quote className="absolute -right-2 -top-2 w-24 h-24 text-white/5" />
          <p className="text-xs font-extrabold tracking-[0.25em] text-[#F5C518]">FRASE INSPIRADORA DE HOY</p>
          <p className="mt-3 text-xl md:text-2xl font-extrabold leading-snug" data-testid="frase-dia-text">
            {frase || "Cargando inspiración..."}
          </p>
        </div>

        <div className="mt-8 flex items-center gap-3">
          <span className="w-12 h-12 rounded-xl bg-[var(--gold)] flex items-center justify-center">
            <Trophy className="w-7 h-7 text-[#0A1C30]" />
          </span>
          <div>
            <p className="text-xs font-extrabold tracking-[0.25em] text-[#B99B2E]">RANKING GENERAL</p>
            <h1 className="text-2xl md:text-3xl font-extrabold text-[#0A1C30]">Tabla de líderes</h1>
          </div>
        </div>

        {/* My position */}
        {mi && (
          <div className="mt-5 rounded-2xl bg-[var(--gold)] p-5 flex items-center justify-between" data-testid="mi-posicion">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-[#0A1C30] text-gold flex items-center justify-center font-extrabold">#{mi.position}</span>
              <div>
                <p className="font-extrabold text-[#0A1C30]">Tu posición</p>
                <p className="text-sm text-[#0A1C30]/70">{mi.programa}</p>
              </div>
            </div>
            <span className="text-2xl font-extrabold text-[#0A1C30]">{mi.puntos} <span className="text-sm">pts</span></span>
          </div>
        )}

        {/* Leaderboard */}
        <div className="mt-6 space-y-2" data-testid="ranking-list">
          {data?.ranking.map((r) => (
            <div
              key={r.position}
              data-testid={`ranking-row-${r.position}`}
              className={`rounded-2xl p-4 flex items-center justify-between ring-1 ${r.is_me ? "bg-[#FFF7DC] ring-[var(--gold)]" : "bg-white ring-black/5"}`}
            >
              <div className="flex items-center gap-3 min-w-0">
                <span className="w-9 h-9 rounded-full flex items-center justify-center font-extrabold text-sm flex-shrink-0"
                  style={{ background: r.position <= 3 ? MEDAL_COLORS[r.position - 1] : "#EDF0F4", color: r.position <= 3 ? "#fff" : "#0A1C30" }}>
                  {r.position === 1 ? <Crown className="w-4 h-4" /> : r.position <= 3 ? <Medal className="w-4 h-4" /> : r.position}
                </span>
                <span className="w-9 h-9 rounded-full overflow-hidden bg-navy flex items-center justify-center flex-shrink-0 ring-1 ring-black/5">
                  {mediaUrl(r.avatar_url) ? (
                    <img src={mediaUrl(r.avatar_url)} alt={r.nombre} className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-xs font-extrabold text-gold">{(r.nombre || "L")[0]?.toUpperCase()}</span>
                  )}
                </span>
                <div className="min-w-0">
                  <p className="font-extrabold text-[#0A1C30] truncate">{r.nombre || "Líder Supera"}</p>
                  <p className="text-xs text-[#6B7688] truncate">{[r.programa, r.pais].filter(Boolean).join(" · ")}</p>
                </div>
              </div>
              <span className="font-extrabold text-[#0A1C30] flex-shrink-0">{r.puntos} <span className="text-xs text-[#6B7688]">pts</span></span>
            </div>
          ))}
          {data && data.ranking.length === 0 && (
            <p className="text-center text-[#6B7688] py-10">Aún no hay puntos en el ranking. ¡Sé el primero!</p>
          )}
        </div>
      </div>
    </div>
  );
}
